import React from "react";
import ReactDOM from "react-dom";

import AidaClient from "./components";

import { default as defaultTheme } from "./theme";

/*
  Aplicação legado do wireChat, colocada aqui para propósitos de não apresentar a nova interface desenvolvida para o
  wireAI. Não irão provavelmente haver muitos desenvolvimentos neste layout.
*/
const init = (config = {}) => {
  const { theme, mountId, ...rest } = config;

  ReactDOM.render(
    <AidaClient
      {...{...rest, tenant: (rest.tenant||'').replaceAll('-','_')}}
      theme={{
        ...defaultTheme,
        ...theme
      }}
    />,
    document.getElementById(mountId || "aida-mount")
  );
};

export default { init };
